import React, { useEffect } from "react";
import { Table } from "react-bootstrap";
import { Annexe7Type } from "../../_App/Types/Entites/Annexe7Type";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  declarationsList,
  findAllDeclarationsApi,
} from "../../_App/Redux/Slices/declaration/declarationSlice";
import {
  exercicesList,
  findAllExercicesApi,
} from "../../_App/Redux/Slices/exercices/exerciceSlice";
import {
  actesList,
  findAllActesApi,
} from "../../_App/Redux/Slices/acte/acteSlice";
import {
  findAllSocietesApi,
  societesList,
} from "../../_App/Redux/Slices/societes/societeSlice";
import { Card, Col, Row } from "react-bootstrap";

const ImpressionAnnexe7 = ({ annexesList }: { annexesList: Annexe7Type[] }) => {
  const declarationId = annexesList[0]?.declaration;

  const allDeclarations = useAppSelector(declarationsList);
  const allExercices = useAppSelector(exercicesList);
  const allActes = useAppSelector(actesList);
  const allSocietes = useAppSelector(societesList);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(findAllActesApi(null));
    dispatch(findAllDeclarationsApi(null));
    dispatch(findAllExercicesApi(null));
    dispatch(findAllSocietesApi(null));
  }, [dispatch]);

  const currentDeclaration = declarationId
    ? allDeclarations.find(
        (declaration: any) => declaration.id === declarationId
      )
    : undefined;
  const currentExercice = currentDeclaration
    ? allExercices.find(
        (exercice) => exercice.id === currentDeclaration.exercice
      )
    : undefined;
  const currentActe = currentDeclaration
    ? allActes.find((acte) => acte.id === currentDeclaration.acte)
    : undefined;

  const currentSociete = currentDeclaration
    ? allSocietes.find((societe) => societe.id === currentDeclaration.declarant)
    : undefined;

  const formattedDate = currentDeclaration
    ? new Date(currentDeclaration.date).toLocaleDateString("fr-FR")
    : "Date non disponible";
  const formattedStartDate = currentExercice
    ? new Date(currentExercice.dateDebut).toLocaleDateString("fr-FR")
    : "Date non disponible";
  const formattedEndDate = currentExercice
    ? new Date(currentExercice.dateFin).toLocaleDateString("fr-FR")
    : "Date non disponible";
  return (
    <div style={{ color: "black" }}>
      <Card>
        <Card.Body>
          <Row>
            <Col>
              <h6 style={{ color: "black" }}>Société</h6>
              {currentSociete && (
                <>
                  <p>Nom : {currentSociete.name}</p>
                  <p>Activité : {currentSociete.activity}</p>
                  <p>Matricule Fiscale : {currentSociete.matriculeFiscale}</p>
                </>
              )}
            </Col>

            <Col>
              <h6 style={{ color: "black" }}>Exercice</h6>
              {currentExercice && (
                <>
                  <p>Date de début : {formattedStartDate}</p>
                  <p>Date de fin : {formattedEndDate}</p>
                  <p>
                    Nombre de jours d'exercice : {currentExercice.nombreJours}
                  </p>
                </>
              )}
            </Col>
            <Col>
              <h6 style={{ color: "black" }}>Déclaration</h6>
              {currentDeclaration && (
                <>
                  <p>Date : {formattedDate}</p>
                  {currentActe && <p>Acte : {currentActe.libelle}</p>}
                </>
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <h1>Annexes 7</h1>
      <Table bordered striped hover style={{ color: "black" }}>
        <thead>
          <tr>
            <th>Type identifiant</th>
            <th>Identifiant</th>
            <th>Catégorie</th>
            <th>Nom / raison sociale</th>
            <th>Activité</th>
            <th>Adresse</th>
            <th>Type Montant</th>
            <th>Montant</th>
            <th>Retenue à la source</th>
            <th>Net Servi</th>
          </tr>
        </thead>
        <tbody>
          {annexesList.map((annexe, index) => (
            <tr key={index}>
              <td>{annexe.typeIdentifiant}</td>
              <td>{annexe.identifiant}</td>
              <td>{annexe.categorie}</td>
              <td>{annexe.name}</td>
              <td>{annexe.activity}</td>
              <td>{annexe.adresse}</td>
              <td>{annexe.typeMontantPaye}</td>
              <td>{annexe.montantPaye}</td>
              <td>{annexe.retenuSource}</td>
              <td>{annexe.netServi}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default ImpressionAnnexe7;
